var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 20H9.83333C8.41885 20 7.06229 20.5619 6.0621 21.5621C5.0619 22.5623 4.5 23.9188 4.5 25.3333V28",
    stroke: "#0050C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.004 22.1688C29.5351 21.6377 29.8335 20.9173 29.8335 20.1662C29.8335 19.415 29.5351 18.6947 29.004 18.1635C28.4729 17.6324 27.7525 17.334 27.0013 17.334C26.2502 17.334 25.5298 17.6324 24.9987 18.1635L19.652 23.5129C19.335 23.8297 19.103 24.2213 18.9773 24.6515L17.8613 28.4782C17.8279 28.5929 17.8259 28.7145 17.8555 28.8303C17.8852 28.9461 17.9454 29.0517 18.0299 29.1363C18.1144 29.2208 18.2201 29.281 18.3359 29.3107C18.4517 29.3403 18.5733 29.3383 18.688 29.3049L22.5147 28.1889C22.9449 28.0632 23.3365 27.8312 23.6533 27.5142L29.004 22.1688Z",
    stroke: "#0050C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 14.6667C16.7789 14.6667 19.1667 12.2789 19.1667 9.33333C19.1667 6.38781 16.7789 4 13.8333 4C10.8878 4 8.5 6.38781 8.5 9.33333C8.5 12.2789 10.8878 14.6667 13.8333 14.6667Z",
    stroke: "#0050C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeEvaluation);
export default __webpack_public_path__ + "static/media/resume-evaluation.3b910c9883ab486b8a896dda1aceca02.svg";
export { ForwardRef as ReactComponent };